import { ProgressLogTransformStream } from './progress-log-transform-stream';
import { ProgressLog } from '@/logger';
import { RangeReadableStream } from '@/rangeReadableStream';
import { ReadableStream as CustomReadableStream } from '@yume-chan/stream-extra';
import { file, write } from 'opfs-tools';

export class FileDownloader {
  private url: URL;

  constructor(url: string) {
    if (url.startsWith('/')) {
      url = window.location.origin + url;
    }
    this.url = new URL(url);

    console.debug(`FileDownloader created for ${this.url}`);
  }

  public async getStream(progressLog?: ProgressLog): Promise<{ size: number; stream: CustomReadableStream<Uint8Array> }> {
    // Initialize
    const headResponse = await fetch(this.url, { method: 'HEAD' });
    if (!headResponse.ok) {
      throw new Error(`Failed to fetch file info: ${headResponse.status} ${headResponse.statusText}`);
    }
    const etag = headResponse.headers.get('etag');
    if (!etag) {
      throw new Error('ETag not found in response');
    }
    const contentLength = headResponse.headers.get('content-length');
    if (!contentLength) {
      throw new Error('Content-Length not found in response');
    }
    // Check if not in cache
    const fileObject = file(`cache/${etag}`);
    let existsInCache = await fileObject.exists();
    console.debug(`File exists in cache: ${existsInCache ? 'yes' : 'no'}`);
    // Check cache size - avoid issue with corrupted files
    if (existsInCache) {
      const size = await fileObject.getSize();
      if (size !== parseInt(contentLength, 10)) {
        console.debug(`File size mismatch: ${size} != ${contentLength}`);
        existsInCache = false;
      }
    }

    if (!existsInCache) {
      await this.saveFileToCache(`cache/${etag}`, progressLog);
    }

    existsInCache = await fileObject.exists();
    if (!existsInCache) {
      throw new Error('File not found in cache');
    }

    let stream = (await fileObject.stream()) as CustomReadableStream<Uint8Array>;
    const size = await fileObject.getSize();

    if (progressLog) {
      progressLog.prefix = `Reading APK from cache`;
      stream = stream.pipeThrough(new ProgressLogTransformStream(progressLog, size)) as CustomReadableStream<Uint8Array>;
    }

    return { size, stream };
  }

  private async saveFileToCache(name: string, progressLog?: ProgressLog): Promise<void> {
    console.debug(`Saving file to cache: ${this.url} to ${name}`);
    const rangeReadableStream = await RangeReadableStream(this.url.toString());
    const size = rangeReadableStream.size;
    let stream = rangeReadableStream.stream;
    if (progressLog) {
      progressLog.prefix = `Downloading APK`;
      stream = stream.pipeThrough(new ProgressLogTransformStream(progressLog, size)) as CustomReadableStream<Uint8Array>;
    }
    await write(name, stream as ReadableStream<Uint8Array>);
  }
}
